import { Box, IconButton, Text } from '@chakra-ui/react';
import * as React from 'react';

import { PaperclipIcon, XIcon } from '@/imports/ui/chakra/feather';

export const FileUploadPreviewItem: React.FC<{
  versionFileId: string;
  fileName: string;
  onClick: (value: { versionFileId: string }) => void;
}> = (props) => {
  return (
    <Box
      bg="gray.50"
      borderRadius="base"
      border="1px"
      borderColor="gray.200"
      display="flex"
      p="4"
      alignItems="center"
    >
      <PaperclipIcon color="gray.500" boxSize={4} mr="4" />
      <Box flex="1">
        <Text fontWeight="semibold" mr="4" color="gray.700">
          {props.fileName}
        </Text>
      </Box>
      <IconButton
        variant="ghost"
        colorScheme="gray"
        icon={<XIcon />}
        aria-label="Remove File"
        onClick={() => props.onClick({ versionFileId: props.versionFileId })}
      />
    </Box>
  );
};
